import { createHttpResourceLocation } from '../../data-access/types/http.location';
import { ReadonlyRepository } from '../abstraction';
import { HttpDataAccess } from '../../data-access/http.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class ReadonlyHttpRepository<TResult, TParams = undefined> implements ReadonlyRepository<TResult, TParams> {

  protected constructor(protected dataAccess: HttpDataAccess,
                        protected url: string) { }

  load(params: TParams): Promise<TResult> {
    const location = createHttpResourceLocation({
      url: this.url,
      pathParams: this.getLoadPathParams(params),
      queryParams: this.getLoadQueryParams(params),
    });
    const payload = this.getLoadPayload(params);
    return this.dataAccess.get(location, payload);
  }

  protected abstract getLoadPathParams(params: TParams): Dictionary<unknown> | undefined;
  protected abstract getLoadQueryParams(params: TParams): Dictionary<unknown> | undefined;
  protected abstract getLoadPayload(params: TParams): unknown | undefined;
}
